import React from 'react';
import Button from 'src/components/10-atoms/button/Button';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import Column from 'src/components/10-atoms/layout/Column';
import CustomScrollView from 'src/components/10-atoms/list-views/CustomScrollView';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useEffectWithCtx from 'src/hooks/useEffectUtils/useEffectWithCtx';
import { NodeType } from 'src/modules/exam-preparation/graphql/common/types/node';
import useI18n from 'src/modules/translations/hooks/useI18n';
import styleUtils from 'src/utils/styles';
import SubjectListAPIHandler from './ListAPIHandler';
import useData from './useData';
const SubjectTab = ({ examLevel, type, isEditMode = false, ...customScrollViewProps }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    const [state, actions] = useData(examLevel, type);
    const hasSubjects = type === NodeType.WRITTEN_SUBJECT
        ? examLevel?.config?.EXAM_LEVEL?.written?.hasSubjects ?? true
        : examLevel?.config?.EXAM_LEVEL?.orals?.hasSubjects ?? true;
    useEffectWithCtx(ctx => {
        ctx.queryFetch();
    }, { queryFetch: actions.query.fetch }, [hasSubjects]);
    return (React.createElement(Column, { flex: true },
        React.createElement(CustomScrollView, { containerStyle: styleUtils.flex, contentContainerStyle: isEditMode ? styleUtils.floatingBtnGutter : undefined, refreshing: state.query.refetching, onRefresh: actions.query.fetch, ...customScrollViewProps },
            React.createElement(Column, { ph: theme.spacing.page, pv: theme.spacing.standard.sm, spacing: theme.spacing.standard.sm },
                React.createElement(SubjectListAPIHandler, { hasSubjects: hasSubjects, queryState: state.query, onRetry: actions.query.fetch, isEditMode: isEditMode, onEditSubject: actions.handleEditSubject, onRearrangeSubjects: actions.handleRearrangeSubjects }))),
        isEditMode && (React.createElement(Button, { variant: "float", onPress: actions.handleAddSubject, LeftIcon: props => React.createElement(FeatherIcon, { name: "plus", ...props }) }, translate('Add Subject')))));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default SubjectTab;
